import { atom } from 'jotai';
export const playingMediaIdsAtom = atom<Set<string>>(new Set<string>());
export const isAnyMediaPlayingAtom = atom(get => {
  const playingIds = get(playingMediaIdsAtom);
  return playingIds.size > 0;
});